import React, { Component, Fragment } from 'react'
import { Calendar } from 'react-calendar-component'
import PropTypes from 'prop-types'

import LoggedSidebar from 'App/Shell/LoggedSidebar'
import { Icon, Button } from 'loyal-react'
import { SchedulingOrderForm } from './SchedulingOrderForm'
import moment from 'moment'
import 'moment/locale/pt-br'
import '@loyal_template/scheduling.css'
import '@loyal_template/tracking.css'
import { ScheduledOrderList } from './ScheduledOrderList'
import ReactPlaceholder from 'react-placeholder'
import SchedulingPlaceholder from './SchedulingPlaceholder'
import Helmet from 'react-helmet'

class Scheduling extends Component {
  constructor (props) {
    super(props)

    this.today = moment(moment().format('MM-DD-YYYY'), 'MM-DD-YYYY')
    const date = moment(this.today)
    const dateSelected = moment(this.today).format()

    const dayStartWeek = parseInt(moment(this.today).format('YYYYMMDD'))
    const dayEndWeek = parseInt(moment(this.today).format('YYYYMMDD'))
    this.state = {
      date,
      dateSelected,
      dayStartWeek,
      dayEndWeek,
      weekDays: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
      view: 'next-orders'
    }
    this.renderHeader = this.renderHeader.bind(this)
    this.renderDay = this.renderDay.bind(this)
    this.handleChangeMonth = this.handleChangeMonth.bind(this)
    this.handleChangeDay = this.handleChangeDay.bind(this)
    this.handleChangeDate = this.handleChangeDate.bind(this)
    this.getScheduleOrdersByDate = this.getScheduleOrdersByDate.bind(this)
    this.onEditServiceItem = this.onEditServiceItem.bind(this)
    this.onDeleteServiceItem = this.onDeleteServiceItem.bind(this)
    this.saveSchedulingOrder = this.saveSchedulingOrder.bind(this)
    this.cancelSchedule = this.cancelSchedule.bind(this)
  }

  componentDidMount () {
    const date = moment(moment().toString())
    const dayStartWeek = parseInt(
      moment(this.state.date)
        .weekday(0)
        .format('YYYYMMDD')
    )
    const dayEndWeek = parseInt(
      moment(this.state.date)
        .weekday(6)
        .format('YYYYMMDD')
    )
    this.setState({ date, dayStartWeek, dayEndWeek })
    this.props.getScheduledOrders(this.today)
  }

  handleChangeDay = date => {
    this.handleChangeDate(date, 'day')
  }

  handleChangeMonth = date => {
    this.handleChangeDate(date)
  }

  cancelSchedule = () => {
    setTimeout(() => {
      this.props.getScheduledOrders(this.today)
      this.setState({ view: 'next-orders' })
    }, 1000)
  }

  handleChangeDate = (date, view) => {
    const dateSelected = date.format()
    const momentDateBeginWeek = moment(dateSelected).weekday(0)
    const momentDateEndWeek = moment(dateSelected).weekday(6)
    const dayStartWeek = parseInt(momentDateBeginWeek.format('YYYYMMDD'))
    const dayEndWeek = parseInt(momentDateEndWeek.format('YYYYMMDD'))
    this.setState({ date: date, dayStartWeek, dayEndWeek, dateSelected })

    if (view) this.setState({ view: view })
  }

  saveSchedulingOrder (schedulingOrder) {
    if (schedulingOrder.id) {
      var participantScehdulePOSTData = JSON.parse(
        JSON.stringify(this.props.participantSchedulesModel)
      )
      participantScehdulePOSTData.serviceItem[
        this.props.indexServiceItem
      ] = schedulingOrder
      this.props.updateScheduleOrder(participantScehdulePOSTData)
    } else {
      this.props.insertScheduleOrder(
        schedulingOrder.serviceId,
        schedulingOrder.operatorKey,
        schedulingOrder.areaCode,
        schedulingOrder.phone,
        schedulingOrder.initialDate,
        schedulingOrder.endDate,
        schedulingOrder.creditValue,
        schedulingOrder.pointValue
      )
    }
    setTimeout(() => {
      this.props.getScheduledOrders(this.today)
      this.setState({ view: 'next-orders' })
    }, 1000)
  }

  renderHeader ({ date, onPrevMonth, onNextMonth }) {
    return (
      <Fragment>
        <Helmet>
          <title>{`Resgates recorrentes - ${process.env.REACT_APP_TITLE || ''}`}</title>
        </Helmet>
        <div className='col-12'>
          <div className='row'>
            <div className='Calendar-header col-12'>
              <button onClick={onPrevMonth}>«</button>
              <div className='Calendar-header-currentDate txt-uppercase'>
                {moment(this.state.dateSelected).format('DD MMMM YYYY')}
              </div>
              <button onClick={onNextMonth}>»</button>
            </div>
            <div className='Calendar-grid Calendar-week-day-names col-12 px-0 mt-1'>
              {this.state.weekDays.map((weekDay, index) => (
                <div
                  key={index}
                  className={`Calendar-grid-item ${
                    weekDay === moment().format('ddd') &&
                  moment(date).format('YYYYMMDD') ===
                    moment().format('YYYYMMDD')
                      ? 'Calendar-grid-item--current'
                      : ''
                  }`}
                >
                  {weekDay}
                </div>
              ))}
            </div>
          </div>
        </div>
      </Fragment>
    )
  }

  renderDay ({ day, onPickDate }) {
    const dayInt = parseInt(day.format('YYYYMMDD'))
    var dayScheduledOrders = this.getScheduleOrdersByDate(day)

    var classNameDayHasScheduledOrder =
      dayScheduledOrders && dayScheduledOrders.length > 0
        ? 'calendar-scheduling'
        : ''

    var classNameSelectedDay =
      moment(this.state.dateSelected).format('YYYYDDD') ===
      day.format('YYYYDDD')
        ? ' color-brand-1 txt-font-body '
        : ''
    var classNameCalendarItem =
      dayInt >= this.state.dayStartWeek && dayInt <= this.state.dayEndWeek
        ? 'Calendar-Item-show'
        : 'Calendar-Item-hidden'

    var classNameToday =
      dayInt === parseInt(this.today.format('YYYYMMDD')) ? 'txt-font-body' : ''

    return (
      <div
        key={day.format('YYYYMMDD')}
        className={`Calendar-grid-item cursor ${classNameCalendarItem} ${classNameDayHasScheduledOrder} ${classNameSelectedDay} ${classNameToday}`}
        onClick={e => onPickDate(day)}
      >
        {day.format('D')}
      </div>
    )
  }

  getScheduleOrdersByDate (date) {
    var year = date.year()
    var month = date.month()
    var day = date.date()

    var yearlySchedules = this.props.scheduledOrders[year]
    if (!yearlySchedules) return []

    var monthlySchedules = yearlySchedules[month]
    if (!monthlySchedules) return []

    var dayleSchedules = monthlySchedules[day]
    if (!dayleSchedules) return []

    return dayleSchedules
  }

  onEditServiceItem (item) {
    this.props.editServiceItem(item)
  }

  onDeleteServiceItem (item) {
    var scheduledOrder = item
    var participantSchedule = JSON.parse(
      JSON.stringify(scheduledOrder.itemParticipantSchedule)
    )

    var serviceItem =
      participantSchedule.serviceItem[scheduledOrder.indexServiceItem]
    serviceItem.status.statusId = 3
    serviceItem.status.statusName = 'Cancelado'
    serviceItem.change = true
    this.props.cancelServiceItem(participantSchedule)
    setTimeout(() => {
      this.props.getScheduledOrders(this.today)
      this.setState({ view: 'next-orders' })
    }, 1000)
  }

  render () {
    var schedulingOrderList = (
      <ScheduledOrderList
        onDelete={this.onDeleteServiceItem}
        onEdit={this.onEditServiceItem}
        scheduledOrders={
          this.state.view === 'next-orders'
            ? this.props.nextOrders
            : this.getScheduleOrdersByDate(this.state.date)
        }
      />
    )
    var schedulingForm = (
      <SchedulingOrderForm
        scheduledOrder={this.props.scheduledOrder}
        onSaveScheduledOrder={this.saveSchedulingOrder}
        onCancelSchedule={this.cancelSchedule}
        loading={this.props.isLoadingUpdate || this.props.isLoadingInsert}
      />
    )

    var body = this.props.scheduledOrder ? schedulingForm : schedulingOrderList

    var title =
      this.state.view === 'next-orders'
        ? 'PRÓXIMOS RESGATES'
        : this.state.date.format('YYYYMMDD') < this.today.format('YYYYMMDD')
          ? 'RESGATES REALIZADOS'
          : 'RESGATES DO DIA'

    return (
      <ReactPlaceholder
        ready={!this.props.isLoading}
        customPlaceholder={<SchedulingPlaceholder />}
      >
        <div className='container-scheduling container-fluid px-0 px-md-1 pt-2 pt-sm-0 bg-ui-4'>
          <div className='container pb-2 pt-4'>
            <div className='row'>
              <LoggedSidebar selected={this.props.location.pathname} />
              <div className='col-12 col-md-8 px-0 px-md-1 border-color-ui-3 bg-white border radius pos-relative'>
                <div className='checkout-step row mx-0 px-3 py-2 border-bottom border-color-ui-3 '>
                  <div className='col mr-auto px-md-0 px-0'>
                    <h3 className='txt-initial color-brand-1 mr-auto'>
                      Resgates agendados
                    </h3>
                  </div>
                </div>

                <div className='pos-relative'>
                  <input
                    id='checkboxToggle'
                    className='checkboxToggle'
                    type='checkbox'
                  />
                  <Calendar
                    onChangeMonth={this.handleChangeMonth}
                    date={this.state.date}
                    onPickDate={this.handleChangeDay}
                    renderHeader={this.renderHeader}
                    renderDay={this.renderDay}
                    containerClassName='row mx-0 mx-sm--1 px-3 bg-ui-4 pt-2 pb-3 border-bottom border-color-ui-3 position-relative'
                    contentClassName='col-12 px-0'
                  />
                  <div className='calendarToggle txt-center pos-absolute bottom-0'>
                    <label htmlFor='checkboxToggle'>
                      <Icon iconName='icon_down' className='icon-sm closed' />
                      <Icon iconName='icon_up' className='icon-sm opened' />
                    </label>
                  </div>
                </div>
                <div className='row mx-0'>
                  <div className='col mr-auto px-md-3 px-0'>
                    <div className='row mx-0 h-100 align-items-center py-half px-3 px-md-0'>
                      <div className='col py-1 d-none d-md-block'>
                        <h4 className='txt-initial color-ui-2 mr-auto'>
                          {title}
                        </h4>
                      </div>
                      <div className='col-12 col-md-auto py-1'>
                        <Button
                          className='btn btn-sm btn-featured '
                          text='AGENDAR NOVO RESGATE'
                          onClick={e => this.props.newServiceItem()}
                        />
                      </div>
                      <div className='col-12 py-1 d-block d-md-none'>
                        <h4 className='txt-initial color-ui-2 mr-auto'>
                          {title}
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
                {body}
              </div>
            </div>
          </div>
        </div>
      </ReactPlaceholder>
    )
  }
}

Scheduling.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired
  }).isRequired,
  scheduledOrders: PropTypes.array,
  nextOrders: PropTypes.array,
  getScheduledOrders: PropTypes.func,
  scheduledOrder: PropTypes.object,
  editServiceItem: PropTypes.func,
  newServiceItem: PropTypes.func,
  updateScheduleOrder: PropTypes.func,
  indexServiceItem: PropTypes.number,
  participantSchedulesModel: PropTypes.object,
  insertScheduleOrder: PropTypes.func,
  isLoadingUpdate: PropTypes.bool,
  isLoadingInsert: PropTypes.bool,
  cancelServiceItem: PropTypes.func,
  isLoading: PropTypes.bool
}

export default Scheduling



// WEBPACK FOOTER //
// ./src/Participant/Scheduling/Scheduling.js